import { createSelector } from "@reduxjs/toolkit";

import selectAuth from "../selectAuth";

const selectUser = createSelector([selectAuth], (auth) => auth.user);

export default selectUser;
